<header class="ib-modals__header">
    <h2 class="ib-heading ib-heading--type-1">{{model.dataModal.TITLE}}</h2>
</header>
<section class="ib-modals__body">
    <div class="ib-layout__line-spacing--large">
        <p class="ib-text ib-text--block">{{model.dataModal.BODY}}</p>
    </div>
</section>
<footer class="ib-modals__footer">
    <div id="contentButton" class="ib-content-buttons">
        <div class="ib-content-buttons__total-container--without-back" style="justify-content: flex-end;">
            <button id="bbki-back-header-accept-btn" class="ib-button ib-button--large-l" type="button" title="Aceptar" (click)="accept()">{{"GIFT_CARDS_MODAL_BUTTON_ACCEPT" | translate}}</button>
        </div>
    </div>
</footer>
